import React from 'react'
import {
  Modal,
  Typography,
  IconButton,
  TextField,
  Button,
  AppBar,
  Tab,
  Tabs,
  Table,
  TableCell,
  TableBody,
  TableRow,
  Checkbox,
} from '@material-ui/core'
import './ReservationLimitReservable.scss'

import CloseIcon from '@material-ui/icons/Close'
import {UsersContext} from '../../context/Users'
import FieldList from './FieldList'
import {useParams} from 'react-router'
import {ReservationConfigurationContext} from '../../context/ReservationConfiguration'
import _ from 'lodash'
import useStateDebounce from '../ReservationApprovalManager/useStateDebounce'
const RootClass = 'reservation-limit-reservable'

const ReservationLimitReservable = ({
  open = false,
  onClose = () => {},
  onSave = (e, selected) => {},
  selectedLimitReservable = [],
}) => {
  const [selected, setSelected] = React.useState([])
  const [search, setSearch, realSearch] = useStateDebounce('', 500)
  const [searchQuery, setSearchQuery] = React.useState('')

  const handleCloseModal = () => {
    onClose()
    setSearchQuery('')
  }

  React.useEffect(() => {
    setSelected(_.cloneDeep(selectedLimitReservable))
  }, [selectedLimitReservable, setSelected])

  const handleChange = (e, field_id, values) => {
    const _selected = [...selected]
    const _field = _selected.find(s => s.field_id === field_id)
    if (_field) {
      _field.value = values
    } else {
      _selected.push({field_id: field_id, value: values})
    }
    setSelected(_selected)
  }

  const handleSave = e => {
    onSave(e, selected)
  }

  const handleSearch = e => {
    if ('Enter' === e.key) {
      setSearchQuery(search)
    }
  }

  return (
    <Modal
      style={{position: 'absolute'}}
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className={`c-res-mod ap-modal ${RootClass}`}>
        <div className="ap-modal__header">
          <Typography className="ap-modal__title">Limit Reservable Items</Typography>
          <Typography className="ap-modal__sub-title">
            Set your criteria for what can be reserved.
          </Typography>
          <IconButton onClick={handleCloseModal} className="ap-modal__btn-x">
            <CloseIcon />
          </IconButton>
        </div>
        <div className="ap-modal__body">
          <div className={`ap-flexbox  ${RootClass}__search-container`}>
            <TextField
              variant="outlined"
              fullWidth
              className={`ap-textfield  ${RootClass}__search-input`}
              label="Search Fields"
              placeholder="Search Fields"
              Value={realSearch}
              onChange={e => {
                setSearch(e.target.value)
                if (e.target.value === '') {
                  setSearchQuery('')
                }
              }}
              onKeyDown={e => handleSearch(e)}
            />
          </div>
          <FieldList search={searchQuery} selected={selected} onChange={handleChange} />
        </div>
        <div className="ap-modal__footer">
          <div className="ap-modal__container ap-modal__container--right">
            <Button
              onClick={handleSave}
              style={{width: 96}}
              className="ap-button ap-button--primary"
            >
              Apply
            </Button>
            <Button
              onClick={handleCloseModal}
              style={{width: 96}}
              className="ap-button ap-button--outlined"
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
export default ReservationLimitReservable
